import {VehicleTypeEnumObject} from '@dms/api/shared';
import {useVehicleCatalogue} from '@dms/shared';

import type {Nullish} from 'shared/web';

/** Passenger-car vehicle catalogue labels for new-vehicle engine, trim, colour and upholstery keys. */
export function useNewVehicleCatalogueLabels() {
  const [catalogue] = useVehicleCatalogue(VehicleTypeEnumObject.VEHICLETYPE_PASSENGER_CAR);
  return {
    getFuelType: catalogue.getFuelType,
    getTransmission: catalogue.getTransmission,
    getDrive: catalogue.getDrive,
    getBodyStyle: catalogue.getBodyStyle,
    getColorType: catalogue.getColorType,
    getInteriorMaterial: catalogue.getInteriorMaterial,
    getEmissionClass: catalogue.getEmissionClass,
    /** "Hybrid · Plug-in hybrid" when the engine carries a hybrid type, otherwise the fuel alone. */
    formatFuel: (engine: {fuel: string; hybridType?: string | Nullish}) =>
      [catalogue.getFuelType(engine.fuel), catalogue.getHybridType(engine.hybridType)]
        .filter(Boolean)
        .join(' · '),
  };
}
